import { Injectable } from '@angular/core';

import { BusinessPackageMediaEnum } from 'app/interfaces';

@Injectable()
export class PackageMediaRulesService {
    isCoverChangeAllowed(mediaTypes: string[]): boolean {
        return mediaTypes.includes(BusinessPackageMediaEnum.Cover);
    }

    isGalleryAllowed(mediaTypes: string[]): boolean {
        return mediaTypes.includes(BusinessPackageMediaEnum.PosImages);
    }

    isLogoChangeAllowed(mediaTypes: string[]): boolean {
        return mediaTypes.includes(BusinessPackageMediaEnum.Logo);
    }

    isServiceImageAllowed(mediaTypes: string[]): boolean {
        return mediaTypes.includes(BusinessPackageMediaEnum.ServiceImage);
    }

    isVideoAllowed(mediaTypes: string[]): boolean {
        return mediaTypes.includes(BusinessPackageMediaEnum.PosVideo);
    }
}
